import { Resource_AppointmentTaskType } from '@/generated/graphql';
import {
  DownloadOutlined,
  FormOutlined,
  InfoCircleOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { CSSProperties, FC } from 'react';

type WithStyleProps = {
  style?: CSSProperties;
};

type FCWithStyle<P = {}> = FC<P & WithStyleProps>;

export const AppointmentTaskTypeToIcon = new Map<Resource_AppointmentTaskType, FCWithStyle>([
  [Resource_AppointmentTaskType.AppointmentTaskTypeInfo, InfoCircleOutlined],
  [Resource_AppointmentTaskType.AppointmentTaskTypeDocumentUpload, UploadOutlined],
  [Resource_AppointmentTaskType.AppointmentTaskTypeDocumentDownload, DownloadOutlined],
  [Resource_AppointmentTaskType.AppointmentTaskTypeForm, FormOutlined],
]);
